<template>
  <vxe-table
    v-if="isLargeScreen"
    class="history-table"
    empty-text="No data"
    border="none"
    :data="actionDataList"
  >
    <vxe-column
      field="channel"
      title="Channel"
      width="30%"
      sortable
      sort-by="channel"
    ></vxe-column>
    <vxe-column
      field="recipient"
      title="Recipient"
      width="70%"
      sortable
      sort-by="recipient"
    ></vxe-column>
  </vxe-table>

  <div v-else class="mobile">
    <div class="icon-group-and-search">
      <div class="icon-group">
        <fa
          icon="sort-amount-down"
          class="icon"
          :class="{ active: isShowSortTool }"
          @click="toggleIsShowSortTool"
        ></fa>
        <fa
          icon="filter"
          class="icon"
          :class="{ active: isShowFilterTool }"
          @click="toggleIsShowFilterTool"
        ></fa>
      </div>
    </div>
    <div v-if="isShowSortTool" class="tool">
      <SortAndFilterToolAlertsRS
        :toolConfig="sortToolConfig"
        @onToolChange="handleSortToolChange"
      ></SortAndFilterToolAlertsRS>
    </div>
    <div v-if="isShowFilterTool" class="tool">
      <SortAndFilterToolAlertsRS
        :toolConfig="filterToolConfig"
        @onToolChange="handleFilterToolChange"
      ></SortAndFilterToolAlertsRS>
    </div>

    <ul>
      <li v-for="(action, index) in processedActionDataList" :key="index">
        <div class="wrapper">
          <span>Channel</span>
          <span>{{ action.channel }}</span>
        </div>
        <div class="wrapper">
          <span>Recipient</span>
          <span>{{ action.recipient }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SortAndFilterToolAlertsRS from '../alertTableParts/SortAndFilterToolAlertsRS.vue';
import {
  ACTION_SORT_OPTION,
  ACTION_FILTER_OPTION
} from '../../../../constants/alertsRoutingStatusConstant';

export default {
  name: 'AlertRSActionsTable',
  components: { SortAndFilterToolAlertsRS },
  props: ['actionDataList'],
  data() {
    return {
      isShowSortTool: false,
      isShowFilterTool: false,
      sortType: 0,
      filterType: 0,
      sortToolConfig: {
        placeholder: 'Sort',
        toolList: [
          { id: ACTION_SORT_OPTION.NONE, text: 'None' },
          {
            id: ACTION_SORT_OPTION.RECIPIENT_ASCENDING,
            text: 'Recipient ascending'
          },
          {
            id: ACTION_SORT_OPTION.RECIPIENT_DESCENDING,
            text: 'Recipient descending'
          }
        ]
      },
      filterToolConfig: {
        placeholder: 'Filter',
        toolList: [
          { id: ACTION_FILTER_OPTION.NONE, text: 'None' },
          {
            id: ACTION_FILTER_OPTION.EMAIL_ONLY,
            text: 'Email only'
          },
          {
            id: ACTION_FILTER_OPTION.SMS_ONLY,
            text: 'SMS only'
          },
          {
            id: ACTION_FILTER_OPTION.SLACK_ONLY,
            text: 'Slack only'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['isLargeScreen']),
    processedActionDataList() {
      let list = [];

      switch (this.filterType) {
        case ACTION_FILTER_OPTION.NONE:
          list = this.actionDataList;
          break;
        case ACTION_FILTER_OPTION.EMAIL_ONLY:
          list = this.actionDataList.filter(
            action => action.channel === 'Email'
          );
          break;
        case ACTION_FILTER_OPTION.SMS_ONLY:
          list = this.actionDataList.filter(action => action.channel === 'SMS');
          break;
        case ACTION_FILTER_OPTION.SLACK_ONLY:
          list = this.actionDataList.filter(
            action => action.channel === 'Slack'
          );
          break;
        default:
          list = this.actionDataList;
          break;
      }

      // deep clone list as list.sort will change the origin list
      list = JSON.parse(JSON.stringify(list));

      switch (this.sortType) {
        case ACTION_SORT_OPTION.NONE:
          break;

        case ACTION_SORT_OPTION.RECIPIENT_DESCENDING:
          list.sort((a, b) => {
            const triggerA = a.recipient.toUpperCase();
            const triggerB = b.recipient.toUpperCase();
            if (triggerB < triggerA) return -1;
            if (triggerB > triggerA) return 1;

            return 0;
          });
          break;
        case ACTION_SORT_OPTION.RECIPIENT_ASCENDING:
          list.sort((a, b) => {
            const triggerA = a.recipient.toUpperCase();
            const triggerB = b.recipient.toUpperCase();
            if (triggerB < triggerA) return 1;
            if (triggerB > triggerA) return -1;

            return 0;
          });
          break;
        default:
          break;
      }

      return list;
    }
  },
  methods: {
    toggleIsShowSortTool() {
      this.isShowSortTool = !this.isShowSortTool;
      if (!this.isShowSortTool) this.sortType = ACTION_SORT_OPTION.NONE;
    },
    toggleIsShowFilterTool() {
      this.isShowFilterTool = !this.isShowFilterTool;
      if (!this.isShowFilterTool) this.filterType = ACTION_FILTER_OPTION.NONE;
    },
    handleSortToolChange(val) {
      this.sortType = val;
    },
    handleFilterToolChange(val) {
      this.filterType = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.history-table {
  /deep/ .vxe-header--row {
    background-color: #ffffff !important;
  }

  /deep/ td.vxe-body--column {
    background-image: none;
  }

  /deep/ td.vxe-body--column {
    padding: 0.25rem 0;
  }

  /deep/ .vxe-table--body {
    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  }
}

.mobile {
  .no-data {
    padding: 1rem 0;
  }

  ul {
    list-style: none;
    padding-bottom: 1.5rem;
  }

  li {
    border-bottom: 1px solid #666;

    &:nth-child(1) {
      border-top: 1px solid #666;
      margin-top: 0.5rem;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    margin: 1.25rem 0;
  }

  .wrapper span:nth-child(1) {
    width: 6rem;
    min-width: 6rem;
    color: $text-black;
    font-weight: 600;
  }

  .wrapper span:nth-child(2) {
    text-align: left;
    width: calc(100% - 6rem);
    word-wrap: break-word;
  }

  .icon-group-and-search {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

    .icon {
      padding: 0.5rem;
      margin-right: 0.5rem;
      width: 2rem;
      height: 2rem;
      color: $icon-grey;
    }

    .active {
      color: $text-light-blue;
    }
  }

  .tool {
    padding-bottom: 0.5rem;
  }
}
</style>
